import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { codeRequired, numberRequired, regionPhoneLength,ConfigurationService } from '@ciam/library';
import { Observable } from 'rxjs';
import { defaultIfEmpty, filter, finalize, switchMap } from 'rxjs/operators';
import { ContactService } from 'src/app/services/contact/contact.service';
import { Contact2faEditService } from 'src/app/services/contact2faEdit/contact2faEdit.service';
import { ContactResponseError, ErrorBlock } from '../../models/ContactResponseError';
import { APIResponse, PhoneNumberDetails } from '../../models/LoginInfoResponse';
import { GdlService } from '../../services/gdl-service/gdl.service';
import { SharedService } from '../../services/shared-service/shared.service';
import { PoprPriority } from '../popr/popr-priority.enum';
import { PoprService } from '../popr/popr.service';
import { TwoFactorComponent } from '../two-factor/two-factor.component';

@Component({
  selector: 'wpro-add-new-number',
  templateUrl: './add-new-number.component.html',
  styleUrls: ['./add-new-number.component.css'],
  standalone: false
})

export class AddNewNumberComponent implements OnInit {
  @Input() deliveryType: string;
  @Output() successfulSaveFlag = new EventEmitter<any>();
  @ViewChild('twoFactorElevationFailure', { read: TemplateRef })
  twoFactorFailureTemplate!: TemplateRef<any>;

  contact: any;
  countryCode: string;
  phoneNumber: string;
  isAddNumber: boolean;
  isFormSubmit = false;
  addSecondaryPhoneForm: UntypedFormGroup;
  //secondaryPhoneSet: CountryPhoneSet = {};
  countryCodeValidator: ValidatorFn | ValidatorFn[] | null = [];
  phoneNumberValidator: ValidatorFn | ValidatorFn[] | null = [Validators.required, Validators.minLength(7)];
  isValidationError: boolean;
  validationErrorList: any[];
  gdlContextPutType = 'PUT';
  gdlServerType = 'server';
  gdlValidationType = 'validation';
  gdlFormView = 'form';
  gdlBackCategory = 'back';
  gdlFormName = 'wpro-loginsecurity-addanumber';

  constructor(
    private contactService: ContactService,
    private poprService: PoprService,
    private config: ConfigurationService,
    private contact2faEditService: Contact2faEditService,
    private activatedRoute: ActivatedRoute,
    public fb: UntypedFormBuilder,
    private gdlService: GdlService,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.addSecondaryPhoneForm = this.fb.group({
      secondaryPhone: new UntypedFormControl('', Validators.compose([numberRequired(), codeRequired(), regionPhoneLength()])),
    });
    this.sharedService.userInfoResponse$.pipe(filter(data => data !== null)).subscribe((data: APIResponse) => {
      this.contact = data.output.userProfile.userProfileAddress.contact;
      const phoneNumberDetails: PhoneNumberDetails[] = data.output.userProfile.userProfileAddress.contactAncillaryDetail.phoneNumberDetails;
      const number = phoneNumberDetails[0].number;
      const secondaryPhoneCode = number.countryCode !== '' ? number.countryCode : '';
      //this.secondaryPhoneSet = { countryCode: secondaryPhoneCode, countryReadonly: true, phoneMaxLength: '10', phoneNumber: '', formValid: true };
      this.addSecondaryPhoneForm.controls.secondaryPhone.setValue({
        phoneCode: secondaryPhoneCode,
        phoneNumber: ''
        //phoneMaxLength: '10',
        //formValid: true
      });
      this.countryCode = `+${number.countryCode}`;
      this.phoneNumber = number.localNumber;
    });
  }

  toggleAddNumber(event: boolean): void {
    this.isAddNumber = event;
    if (!event) {
      //this.secondaryPhoneSet.formValid;
      //this.secondaryPhoneSet.phoneNumber = '';
      this.isValidationError = false;
      this.validationErrorList = [];
      this.gdlService.triggerGdlLogEvent(this.gdlFormView, this.gdlBackCategory, { name: this.gdlFormName });
    }
    this.gdlService.triggerGdlLogEvent('form', 'view', { name: 'wpro-loginsecurity-addanumber' });
  }

  addNewNumber(): void {
    if (this.addSecondaryPhoneForm.valid) {
      this.gdlService.triggerGdlLogEvent('form', 'submit', { name: 'wpro-loginsecurity-addanumber' });
      // const secondaryNumber = {
      //   secondaryPhoneCountryCode: this.secondaryPhoneSet.countryCode,
      //   secondaryPhoneNumber: this.secondaryPhoneSet.phoneNumber
      // };
      const secondaryNumber = {
        secondaryPhoneCountryCode: this.addSecondaryPhoneForm.controls.secondaryPhone.value.phoneCode,
        secondaryPhoneNumber: this.addSecondaryPhoneForm.controls.secondaryPhone.value.phoneNumber
      };
      const contactParams = {
        firstName: this.contact?.personName?.firstName,
        lastName: this.contact?.personName?.lastName,
        emailAddress: this.contact?.emailAddress,
        //secondaryPhoneCountryCode: this.secondaryPhoneSet.countryCode,
        //secondaryPhoneNumber: this.secondaryPhoneSet.phoneNumber
        secondaryPhoneCountryCode: this.addSecondaryPhoneForm.controls.secondaryPhone.value.phoneCode,
        secondaryPhoneNumber: this.addSecondaryPhoneForm.controls.secondaryPhone.value.phoneNumber
      };
      let queryParams = {};
      this.activatedRoute.queryParamMap
        .subscribe((params) => {
          queryParams = params;
        });
      this.deActivateForm();

      this.contactService.updateContactInformation(queryParams, contactParams, true).subscribe(() => {
        this.activateForm();
        this.poprService.createToast(PoprPriority.SUCCESS, '{"translateKey": "successNotification.contactUpdateDescription"}');
        this.successfulSaveFlag.emit({
          isSuccess: true,
          secondaryNumberDetails: secondaryNumber
        });
      }, (error) => {
        this.activateForm();
        this.handleUpdateError(error);
      });
    }
    else{
      this.gdlService.captureGdlErrorMessages(this.gdlValidationType,'Error', this.gdlContextPutType, 'Invalid phone number format');
    }
  }

  handleUpdateError(err: HttpErrorResponse): void {
    const errorCodeValue = err?.error?.errors[0].code.toLowerCase();
    const errorCodes = errorCodeValue?.replaceAll('.', '_');

    if (err.status >= 500) { //API failed to save for unhandled reasons
      this.poprService.createToast(PoprPriority.ERROR, '{"translateKey": "errorNotification.contactUpdateDescription"}');
      this.gdlService.captureGdlErrorMessages(this.gdlServerType, err, this.gdlContextPutType);
    } else {
      this.gdlService.captureGdlErrorMessages(this.gdlValidationType, err.message, this.gdlContextPutType, 'wpro-loginsecurity-addanumber');
      if (errorCodes === 'userelevation_authorization_invalid') {
        this.elevateAuthority$().subscribe((isElevated) => {
          if (isElevated) this.addNewNumber();
          else this.poprService.createToast(PoprPriority.ERROR, this.twoFactorFailureTemplate);
        });
      } else { //else validation errors
      const responseError = err.error as ContactResponseError;
      this.validationErrorList = [];
      responseError?.errors.forEach((error) => {
        this.validationErrorList.push((error as ErrorBlock).message);
      });
      this.isValidationError = true;
    }
   }
  }

  /// To open Iframe modal popup
  elevateAuthority$(): Observable<boolean> {
    const modal = this.poprService.createModal(TwoFactorComponent);
    return modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    );
  }

  activateForm(): void {
    this.isFormSubmit = false;
    this.addSecondaryPhoneForm.enable();
  }

  deActivateForm(): void {
    this.isFormSubmit = true;
    this.addSecondaryPhoneForm.disable();
  }

  // onPhoneSecondaryNumberChanged(value: CountryPhoneSet): void {
  //   this.secondaryPhoneSet = value;
  // }
}
